export const environment = {
  production: true,
  debug: false,
  api: 'https://api.brainssoftware-apps.nl'
};
